import { useCallback } from "react"

import toast from "react-hot-toast"
import { useTranslation } from "react-i18next"
import { Icon } from "semantic-ui-react"
import type { OpenAPI } from "simplydo/interfaces"

import api from "api"
import { TooltipButton } from "components/lib/UI"
import { useAppSelector } from "store"
import util from "utils/utils"

import PinIdeaHelper from "../../PinIdeaHelper"

type PinActionProps = {
  idea: OpenAPI.GET<"/ideas/{id}">["response"]
  onUpdateIdea: (idea: Partial<OpenAPI.GET<"/ideas/{id}">["response"]>) => void
}

const PinAction = ({ idea, onUpdateIdea }: PinActionProps) => {
  const user = useAppSelector((state) => state.user)
  const { t } = useTranslation()
  const ideaId = idea?._id

  const pinIdea = useCallback(() => {
    api.ideas.updateStatus(
      ideaId,
      { isPinned: !idea?.isPinned },
      (ideaStatus) => {
        onUpdateIdea({ isPinned: ideaStatus.isPinned })
      },
      (err) => toast.error(err.message),
    )
  }, [ideaId, idea, onUpdateIdea])

  if (!util.canManageChallenge(user, idea.ownerChallenge)) {
    return null
  }
  if (!util.hasPermission(user, "challenge.pinIdeas", idea.challenge)) {
    return null
  }
  return (
    <TooltipButton
      icon
      onClick={pinIdea}
      tooltip={
        <div>
          <b>{idea?.isPinned ? `Un-pin ${t("generic.idea")}` : `Pin ${t("generic.idea")}`}</b>
          <PinIdeaHelper challenge={idea.ownerChallenge} />
        </div>
      }
    >
      <Icon name="pin" style={{ transform: idea?.isPinned ? "rotate(45deg)" : "rotate(0deg)" }} />
    </TooltipButton>
  )
}

export default PinAction
